module.exports = __webpack_public_path__ + "static/media/objects2_21.aa15d2ff.svg";